import XLSX from 'xlsx'

export default class CsvFiles {
  constructor () {
    this.downloadCSV = this.downloadCSV.bind(this)
    this.exportTableToCSV = this.exportTableToCSV.bind(this)
    this.importCSVToTable = this.importCSVToTable.bind(this)
  }

  downloadCSV (csv) {
    // Crée un lien vers le fichier plutôt que de forcer un téléchargement
    return window.URL.createObjectURL(new Blob(['\ufeff', csv], { type: 'text/csv' }))
  }

  downloadXLSX (items, filename) {
    // Création d'un nouveau fichier
    const workbook = XLSX.utils.book_new()
    // Ajout de notre page
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(items, { skipHeader: true }),
    )
    // Force un téléchargement côté client
    XLSX.writeFile(workbook, filename)
  }

  exportTableToCSV (items) {
    var csv = []

    // Mise en forme des données
    items.forEach(item => {
      var row = []
      row.push('"' + item.email + '"')
      item.tags.forEach(tag => {
        row.push('"' + tag.tag + '"')
      })

      csv.push(row.join(';'))
    })

    // Retourne le lien de téléchargement du fichier
    return new Promise((resolve) => {
      resolve(this.downloadCSV(csv.join('\n')))
    })
  }

  exportTableToXLSX (items, filename) {
    var formattedItems = []

    // Mise en forme des données
    items.forEach(item => {
      const formattedItem = {}
      formattedItem.email = item.email
      item.tags.forEach((tag, i) => {
        formattedItem['tag' + i] = tag.tag
      })
      formattedItems.push(formattedItem)
    })

    // télécharge le fichier
    this.downloadXLSX(formattedItems, filename)
  }

  importCSVToTable (items) {
    const tags = []

    // Mise en forme des données
    items.forEach(item => {
      let userEmail
      item.forEach((it, i) => {
        if (i === 0) {
          userEmail = it
        } else {
          if (it !== '') {
            tags.push({
              email: userEmail,
              tag: it,
            })
          }
        }
      })
    })
    return tags
  }

  importXLSXToTable (items, nbTagMax) {
    var tags = []

    // Mise en forme des données
    items.forEach(emailTags => {
        for (var i = 0; i < nbTagMax; i++) {
          var tagIncrement = 'tag'
          var tuple = {}
          tagIncrement += i

          if (emailTags[tagIncrement]) {
            tuple.email = emailTags.email
            tuple.tag = emailTags[tagIncrement]

            tags.push(tuple)
          }
        }
      },
    )
    return tags
  }

  // Retourne une promesse de lecture et de transformation en json du fichier
  readXLSX (file, nbTagMax) {
    return new Promise((resolve, reject) => {
      var rABS = true
      var reader = new FileReader()

      // On prépare les headers qui permmettent de transformer le xlsx en json
      var headers = []
      headers.push('email')
      for (var i = 0; i < nbTagMax; i++) {
        var tagIncrement = 'tag'
        tagIncrement += i
        headers.push(tagIncrement)
      }

      // On lit dans le fichier
      reader.onload = (e) => {
        var data = e.target.result
        if (!rABS) data = new Uint8Array(data)
        var workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' })

        // On converti le fichier xlsx en json
        var tab = XLSX.utils.sheet_to_json(
          workbook.Sheets[workbook.SheetNames[0]],
          { header: headers },
        )

        resolve(tab)
      }

      if (rABS) {
        reader.readAsBinaryString(file)
      }
    })
  }
}
